import { React, PT, withRouter, connect } from '@gasbuddy/react';
import { Grid, Container, Button } from 'semantic-ui-react';
import { Redirect } from 'react-router';
import { Auth, Nav, BrandEdit } from '../../components';
import { Role } from '../../roles';
import { Action } from '../../reducers/actions';

class NewBrandPage extends React.Component {
  state = {
    brand: {},
  };

  save = () => {
    const { brand: { brand }, dispatch } = this.props;
    const { brand: stateBrand } = this.state;
    // TODO this seems to indicate a misunderstanding of how state works, but I'm just fixing lint.
    this.setState({ brand });
    dispatch({
      type: Action.Poi.BrandCreateRequested,
      meta: { apiAction: true },
      payload: {
        url: '/poi/brand/create/new',
        body: stateBrand,
      },
    });
  }

  editHandlerFactory = (name, type) => {
    const theName = name;
    const theType = type;
    return function eventHandler(e, result) {
      const { brand } = this.state;
      const stateChange = { brand };
      if (theType === 'string') { stateChange.brand[theName] = result.value; }
      if (theType === 'bool') { stateChange.brand[theName] = (theName === 'allow_brand_sharing') ? !result.checked : result.checked; }
      this.setState(stateChange);
    }.bind(this);
  }

  render() {
    const { brand } = this.props;
    if (brand.redirect) {
      return (<Redirect push to={brand.redirect} />);
    }
    const showBrand = brand || NewBrandPage.defaultProps;
    return (
      <Auth forRoles={[Role.POI]}>
        <Nav>
          <BrandEdit brand={showBrand} editHandler={this.editHandlerFactory} />
          <Grid columns={16}>
            <Grid.Row>
              <Grid.Column width={6} />
              <Grid.Column width={4}>
                <Container style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button onClick={this.save}>Create New</Button>
                </Container>
              </Grid.Column>
              <Grid.Column width={6} />
            </Grid.Row>
          </Grid>
        </Nav>
      </Auth>
    );
  }
}

const mapStateToProps = state => state;

export const NewBrand = withRouter(connect(mapStateToProps)(NewBrandPage));

NewBrandPage.defaultProps = {
  brand: PT.shape({
    brand: PT.shape({
      brand_id: 0,
      name: '',
      logo_version: 1,
      image_url: '',
      description: '',
    }),
    redirect: '',
  }),
};

NewBrandPage.propTypes = {
  dispatch: PT.func.isRequired,
  brand: PT.shape({
    brand: PT.shape({
      brand_id: PT.number,
      name: PT.string,
      logo_version: PT.number,
      image_url: PT.string,
      description: PT.string,
      is_fuel: PT.boolean,
      is_cstore: PT.boolean,
      allow_sharing: PT.boolean,
      display: PT.boolean,
    }),
    redirect: PT.string,
  }),
};
